export const iconFontAwesomeChartsDiagramsChartColumn = (
	<i className="fa-solid fa-chart-column"></i>
);
